import { useRouter } from "next/router";

import { useTranslator } from "@eo-locale/react";

import { useAppDispatch } from "@/redux/store/hooks";
import { signOutUser } from "@/redux/features/user/thunk";
import useEmbeds from "./useEmbeds";
import usePinned from "./usePinned";
import { useToast } from "@/storybook-components";

const useLogout = () => {
  const toast = useToast();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { isPinned } = usePinned();
  const { translate } = useTranslator();
  const { isInsideIframeAndOnCurrentUrl } = useEmbeds();

  const reloadPage = () => {
    if (isInsideIframeAndOnCurrentUrl || isPinned) {
      window.parent.location.reload();
      return;
    }
    router.reload();
  };

  const logOut = async () => {
    await dispatch(signOutUser()).then((res) => {
      if (res?.payload.status === 404)
        return toast({
          id: "logout-toast",
          title: translate("errors.sorrySomethingWentWrong"),
          status: "error",
          isClosable: true
        });

      reloadPage();
    });
  };

  return { logOut };
};

export default useLogout;
